<template>
    <div>
        <InfoIcon v-if="showInfoIcon" v-tooltip="{ content: $t('CourseListFilter.here_filter_bla_bla'), html: true }"/>
        <TotemTag
            :name="datesTag.translatedName"
            :label="datesTag.translatedLabel"
            size="small"
            :key="datesTag.filterKey+'-'+datesTag.value"
            :class="`${$totemLang}-${datesTag.filterKey}`"
            :clear="false"
        />
        <TotemTag
            v-for="{ label, filterKey, value, count, translatedName, translatedLabel } in filterTags.withoutDates"
            :name="translatedName"
            :label="translatedLabel"
            :count="count"
            size="small"
            :key="filterKey+'-'+value"
            @handleClick="removeFilter(value, filterKey)"
            :class="`${$totemLang}-${filterKey}`"
        />
    </div>
</template>

<script>
    import InfoIcon from 'components/searchable-listing/filters-elements/InfoIcon'
    import filteringHelper from 'components/user/organizationreport/filters/helpers/filteringHelper'
    import moment from 'moment'

    export default {
        name: 'Tags',
        mixins: [ filteringHelper ],
        inject: ['tab'],
        components: {
            InfoIcon
        },
        props: {
            showInfoIcon: {
                type: Boolean,
                default: false
            },
            tags: {
                type: Array,
                required: true
            }
        },
        computed: {
            filterTags () {
                const objKeys = ['startDate', 'endDate']
                const startDate = this.tags.find(el => el.filterKey === 'startDate')
                const endDate = this.tags.find(el => el.filterKey === 'endDate')
                const withoutDates = this.tags
                    .filter(el => !objKeys.includes(el.filterKey))
                    .sort((a,b) => a.order - b.order)

                return { startDate, endDate, withoutDates }
            },
            datesTag () {
                let startDate = moment(this.filterTags?.startDate?.translatedName).format('DD.MM.YYYY')
                let endDate = moment(this.filterTags?.endDate?.translatedName).format('DD.MM.YYYY')

                return {
                    ...this.filterTags.startDate,
                    translatedLabel: `${this.$t('ReportingFilters.dates')}`,
                    translatedName: `${startDate} - ${endDate}`
                }
            }
        },
        methods: {
            removeFilter (value, key) {
                this.$store.dispatch(this.getRemoveFilterRoute, { key, value })
            }
        }
    }
</script>
